import { TranslationLabels } from '@generated/translation-labels';
import Button from '@material-ui/core/Button';
import { useTranslation } from '@shared/translations';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { TICKETING_PATHS } from '../../routing';

export const HomeButton: FC = () => {
  const { t } = useTranslation();

  return (
    <Button
      component={Link}
      to={TICKETING_PATHS.INDEX}
      variant="outlined"
      color="primary"
      size="large"
    >
      {t(TranslationLabels.ticketingServiceRequestConfirmationButtonHomeLabel)}
    </Button>
  );
};
